import _ from 'lodash'

export function apiHandleStatus(res, allowedStatuses) {
    let statusCode = null

    if (!res || 'undefined' === typeof res) {
        throw new Error('NoResources')
    }

    if (res.status_code) {
        statusCode = res.status_code
    } else if(res.status) {
        statusCode = res.status
    }

    if (null == statusCode) {
        throw new Error('NoStatusCode')
    }

    if(_.includes(allowedStatuses, statusCode)) {
        // @BUG, api can return errors with a 200 code if error field is present
        if(res.error != null) {
            throw new Error(res.error)
        } else {
            return statusCode
        }
    } else {
        throw new Error(statusCode)
    }
}



// WEBPACK FOOTER //
// ./src/lib/apiHelpers.js